import { render, staticRenderFns } from "./CardMealDislike.vue?vue&type=template&id=1e5b1d76"
import script from "./CardMealDislike.vue?vue&type=script&lang=js"
export * from "./CardMealDislike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports